/* La Moda Clothing - consolidated front-end behaviour.
   Extracted from inline <script> blocks in layout/theme.liquid.
   Loaded with defer so it no longer blocks parsing. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1. TRADE SHOW BANNER - self-expiring
     Previously hardcoded inline with no end date, so it would have kept
     advertising a finished show indefinitely. It now removes itself the
     day after the show ends. Update the three values below per show.
  --------------------------------------------------------------- */
  var SHOW = {
    name: 'WWIN Show Las Vegas',
    detail: 'Booth #1722 &middot; August 9 - 12, 2026',
    endsISO: '2026-08-12'
  };

  function tradeShowBanner() {
    var ends = new Date(SHOW.endsISO + 'T23:59:59');
    if (isNaN(ends.getTime()) || new Date() > ends) return;
    var b = document.createElement('div');
    b.id = 'swim-show-banner';
    b.style.cssText = 'background:linear-gradient(90deg,#FF6B6B 0%,#FFB347 100%);color:#fff;text-align:center;padding:11px 16px;font-weight:600;font-family:-apple-system,BlinkMacSystemFont,sans-serif;font-size:15px;width:100%;box-sizing:border-box;';
    b.innerHTML = 'Visit us at <strong style="font-weight:800">' + SHOW.name + '</strong> &middot; ' + SHOW.detail;
    var h = document.querySelector('.site-header');
    if (h && h.parentNode) { h.parentNode.insertBefore(b, h.nextSibling); }
    else { document.body.insertBefore(b, document.body.firstChild); }
  }

  /* ---------------------------------------------------------------
     2. LAZY LOADING
     The homepage was shipping 87 images with only 5 lazy-loaded, so 82
     images competed with the LCP element for bandwidth. Everything below
     the first three images is deferred; the first slide is prioritised.
  --------------------------------------------------------------- */
  function lazyImages() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('img'));
    imgs.forEach(function (img, i) {
      if (i < 3) return;
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
    var hero = document.querySelector('.rt-slideshow-slide img, .swiper-slide img, .slideshow__image img');
    if (hero) { hero.loading = 'eager'; hero.fetchPriority = 'high'; hero.decoding = 'sync'; }
  }

  /* ---------------------------------------------------------------
     3. ALT TEXT FALLBACK
     A stopgap only. Real alt text belongs on the image record in Shopify;
     this exists so images are never left with an empty alt attribute.
     Note it runs after paint, so it does not help crawlers that read raw HTML.
  --------------------------------------------------------------- */
  function altFallback() {
    document.querySelectorAll('img').forEach(function (img) {
      if (img.alt && img.alt.trim()) return;
      var alt = 'La Moda Clothing wholesale resort wear';
      if (img.closest('.site-header__logo-image')) {
        alt = 'La Moda Clothing - wholesale resort wear and beachwear supplier';
      } else if (img.closest('.rt-slideshow-slide, .swiper-slide, .slideshow')) {
        alt = 'La Moda Clothing wholesale resort wear collection';
      } else {
        var card = img.closest('.product-card, .grid-view-item');
        var titleEl = card && card.querySelector('.product-card__title, .grid-view-item__title, h3, h4');
        if (titleEl && titleEl.textContent.trim()) {
          alt = titleEl.textContent.trim().replace(/\s+/g, ' ') + ' - wholesale from La Moda Clothing';
        }
      }
      img.alt = alt;
    });
  }

  /* ---------------------------------------------------------------
     4. SKELETON LOADER
  --------------------------------------------------------------- */
  function skeleton() {
    document.querySelectorAll('img.grid-view-item__image').forEach(function (img) {
      var wrap = img.closest('.grid__image');
      if (!wrap) return;
      if (img.complete) { wrap.classList.add('lm-loaded'); }
      else { img.addEventListener('load', function () { wrap.classList.add('lm-loaded'); }); }
    });
  }

  /* ---------------------------------------------------------------
     5. COLLECTION DESCRIPTION EXPANDER
     Replaces the old CSS that hid the description entirely. The text is
     now genuinely visible and the buyer can expand it.
  --------------------------------------------------------------- */
  function rteExpander() {
    if (!document.body.classList.contains('template-collection')) return;
    var rte = document.querySelector('.template-collection .rte');
    if (!rte || !rte.textContent.trim()) return;
    if (rte.scrollHeight <= rte.clientHeight + 8) return;

    var wrap = document.createElement('div');
    wrap.className = 'lm-rte-wrap';
    rte.parentNode.insertBefore(wrap, rte);
    wrap.appendChild(rte);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lm-rte-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more about this category';
    wrap.parentNode.insertBefore(btn, wrap.nextSibling);

    btn.addEventListener('click', function () {
      var open = rte.classList.toggle('lm-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more about this category';
    });
  }

  function init() {
    try { tradeShowBanner(); } catch (e) {}
    try { lazyImages(); } catch (e) {}
    try { altFallback(); } catch (e) {}
    try { skeleton(); } catch (e) {}
    try { rteExpander(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
